import { useState } from 'react'

import { useBackendPaginatedQuery, BackendPaginatedConfig } from '../useBackendPaginatedQuery'

export interface UseLiquorfileSearchProps {
  debounce?: number
  defaultSearchValue?: string
  page?: number
  limit?: number
}

export function useLiquorfileSearch<LiquorfileProduct>(
  options: UseLiquorfileSearchProps = {},
  config: BackendPaginatedConfig<LiquorfileProduct> = {},
) {
  const { debounce = 500, defaultSearchValue = '', limit = 10, page = 1 } = options

  const [searchValue, setSearchValue] = useState(defaultSearchValue)

  const params = { search: searchValue, limit, page }
  const _config = { ...config, retry: 3, debounce, enabled: !!searchValue }

  const search = useBackendPaginatedQuery<LiquorfileProduct>(
    ['/products/liquorfile', { params }],
    _config,
  )

  return {
    ...search,
    searchValue,
    setSearchValue,
  }
}

export default useLiquorfileSearch
